import React from "react";

import { removeQueryParams } from "@/lib/utils";
import useGlobalStore from "@/stores/useGlobalStore";

import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const BusinessSwitcher = ({ isMobile }) => {
  const { business, user, availableBusinesses } = useGlobalStore();

  const currentBusiness = availableBusinesses?.find((item) => item.code === business);

  const handleBusinessChange = (businessCode) => {
    sessionStorage.setItem("business", businessCode);
    useGlobalStore.setState({ business: businessCode });
    removeQueryParams("business");
    window.location.reload();
  };

  return (
    <Popover>
      <PopoverTrigger>
        <div className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 px-2 rounded-md transition-colors">
          {!isMobile && <span className="font-normal text-sm">{user?.name}</span>}
          <div className="h-7 w-7 rounded-full text-md flex items-center justify-center text-white" style={{ backgroundColor: currentBusiness?.background }}>
            <img src={currentBusiness?.icon} alt={currentBusiness?.name} className="w-full h-full object-cover" />
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-52 p-2">
        <div className="text-sm font-medium mb-2 text-gray-700">Chọn ngành</div>
        <div className="space-y-1">
          {availableBusinesses?.map((business) => (
            <div key={business.code} className={`flex items-center gap-2 p-2 rounded-md cursor-pointer hover:bg-gray-100`} onClick={() => handleBusinessChange(business.code)}>
              <div className="h-6 w-6 rounded-full text-sm flex items-center justify-center text-white">
                <img src={business.icon} alt={business.name} className="w-full h-full object-cover" />
              </div>
              <span>{business.name}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default BusinessSwitcher;
